module.exports = __webpack_public_path__ + "static/Real-time-Notifications-72827d5a745bb87a20fcf21eb661914b.jpg";